export default {
  massConfirmTransport: item => item.cardStatus === 'Zrealizowane przejęcie',
  changeCoursesDueDates: item => item.courseStatus === 'Zaplanuj'
}
